import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.12.4_@types+node@20.14.15_eslint@8.57.0_rollup@4.20.0_sass@1.77.2_stylelint@14.16.1_ty_zumdled7skmvuz2bz25z37qfyu/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}